import React from 'react'
import { Signin } from '../../components/Signin'
// import { Container } from './style'

export const SigninPage = () => {
  return (  
      <Signin/> 
   )
}
